<mat-card class="buy-sell-plan-details">
    <mat-card-title>
        <h6 appLocalizationPopupDirective localizationCode="BuySellPlanDetails">
            {{ 'BuySellPlanDetails' | translate: {Default: "Buy/Sell Plan Details"} }}
        </h6>
    </mat-card-title>
    
    <mat-card-content>
        <div class="detail-row">
            <div class="label">{{getFieldName('tbl_BsPlanName')}}</div>
            <div class="value">{{buySellPlan?.name}}</div>
        </div>
        <div class="detail-row">
            <div class="label">{{getFieldName('tbl_BsPlanDescription')}}</div>
            <div class="value">{{buySellPlan?.description}}</div>
        </div>
        <div class="detail-row">
            <div class="label">{{getFieldName('tbl_BsPlanTimeoffType')}}</div>
            <div class="value">{{buySellPlan?.timeOffType?.name}}</div>
        </div>
    </mat-card-content>
</mat-card>